import { lazy } from 'react';

const MediaLibraryRoutes = [
  {
    path: 'media-library',
    component: lazy(() => import('views/media-library')),
  },
];

export default MediaLibraryRoutes;
